// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1C1oZ","buttons":"RemoveExpirationActionButtons_buttons__h5Y-2"};